export const correctionRu = {
  "submit": "Отправить обращение",
  "saveDraft": "Сохранить черновик",
  "submitHelp": "Проверьте данные и нажмите «Отправить обращение». Руководитель установки рассмотрит его и определит дальнейшие действия. Сама отправка не запускает переделку и не меняет стоимость заказа.",
  "draftHelp": "До сдачи изделия нажмите «Сохранить черновик»: вы вернётесь к списку и сможете продолжить позже. Черновик не меняет этап заказа и не отправляется руководителю.",
  "editReportHelp": "Уточнять отправленное обращение можно, пока по изделию не утверждено решение и не начато исправление. Обращения по другим изделиям сохранятся.",
  "editReport": "Уточнить причину",
  "reportedRows": "Отправлено: строки {{rows}}",
  "draftRows": "Черновик: строки {{rows}}",
  "draftStatus": "Черновик",
  "sentStatus": "Отправлено",
  "removeDraft": "Удалить черновик",
  "removeDraftTitle": "Удалить черновик этого изделия?",
  "removeDraftDescription": "Сохранённые данные этого изделия будут удалены. Этап заказа и обращения по другим изделиям не изменятся.",
  "removeReport": "Отменить обращение",
  "removeReportTitle": "Отменить обращение по этому изделию?",
  "removeReportDescription": "Причина и исправления по этому изделию будут отозваны. Обращения по другим изделиям сохранятся.",
  "tab": { "parameters": "Параметры", "sizes": "Размеры" },
  "originalValue": "Было: {{value}}",
  "changed": "Изменено",
  "resetComposition": "Отменить изменения комплектации",
  "resetCompositionTitle": "Отменить изменения комплектации?",
  "resetCompositionConfirm": "Да, отменить",
  "keepChanges": "Оставить",
  "expandRow": "Развернуть",
  "collapseRow": "Свернуть",
  "includeRow": "Добавить в обращение",
  "excludeRow": "Отменить изменения",
  "rowIncluded": "В обращении",
  "sizeRows": "Строк размеров: {{count}}",
  "selectedRows": "Выбраны строки: {{rows}}",
  "rowNote": "Примечание к этой строке",
  "chooseSizes": "Разверните нужную строку и внесите исправления.",
  "sizeNumber": "Строка размера № {{number}}",
  "sharedSelection": "Изменения общей комплектации применятся ко всем доступным строкам этого замера.",
  "sizeLocked": "По этой строке решение уже принято или она недоступна для текущего выезда.",
  "customerAgreement": "Согласованные условия с клиентом / результат проверки его пожеланий",
  "confirmAgreement": "Подтвердить согласование и исправленный вариант",
  "title": "Уточнение изделия",
  "add": "Указать причину",
  "editProposal": "Посмотреть и уточнить вариант",
  "attached": "Вариант приложен к сообщению",
  "edit": "Поправить",
  "attach": "Приложить вариант",
  "compare": "Сравнить параметры",
  "before": "Было в заказе",
  "after": "Должно быть",
  "quantity": "Количество с ошибкой",
  "of": "из",
  "comment": "Что именно не так",
  "photo": "Фото",
  "takePhoto": "Сделать фото",
  "choosePhoto": "Выбрать из галереи",
  "removePhoto": "Убрать фото из уточнения",
  "situation": "Ситуация",
  "notes": "Сторона управления, цепь и примечание к изделию",
  "correctSpecification": "Правильная комплектация",
  "agreement": "Изменение пожеланий клиента требует отдельного согласования условий и возможной доплаты.",
  "kind": {
    "SPECIFICATION_ERROR": "В заказе указано неверно",
    "ORIGINAL_CORRECT": "Изделие не соответствует заказу",
    "REMEASURE": "Нужен повторный замер",
    "CUSTOMER_REFUSAL": "Клиент отказался от изделия",
    "CUSTOMER_CHANGE": "Клиент изменил пожелания"
  },
  "managerTitle": "Предложение установщика",
  "managerHint": "Проверьте описание и параметры. Исправление можно уточнить перед решением; сумма заказа не пересчитывается.",
  "reviewed": "Предложение рассмотрено. Запуск — после подтверждения решения.",
  "adopt": "Открыть предложенный вариант",
  "originalReason": "Почему сохраняем исходную комплектацию / результат повторной проверки",
  "keepOriginal": "Рассмотрено — использовать исходный заказ"
};
export const correctionUz = {
  "submit": "Murojaatni yuborish",
  "saveDraft": "Qoralamani saqlash",
  "submitHelp": "Ma’lumotlarni tekshirib, «Murojaatni yuborish» tugmasini bosing. O‘rnatish rahbari murojaatni ko‘rib chiqib, keyingi ishlarni belgilaydi. Yuborishning o‘zi qayta tayyorlashni boshlamaydi va buyurtma narxini o‘zgartirmaydi.",
  "draftHelp": "Mahsulotni topshirguncha «Qoralamani saqlash» tugmasini bosing: ro‘yxatga qaytasiz va keyin davom ettira olasiz. Qoralama buyurtma bosqichini o‘zgartirmaydi va rahbarga yuborilmaydi.",
  "editReportHelp": "Mahsulot bo‘yicha qaror tasdiqlanib yoki tuzatish boshlanmaguncha yuborilgan murojaatni aniqlashtirish mumkin. Boshqa mahsulotlar bo‘yicha murojaatlar saqlanadi.",
  "editReport": "Sababni aniqlashtirish",
  "reportedRows": "Yuborilgan qatorlar: {{rows}}",
  "draftRows": "Qoralama qatorlar: {{rows}}",
  "draftStatus": "Qoralama",
  "sentStatus": "Yuborilgan",
  "removeDraft": "Qoralamani o‘chirish",
  "removeDraftTitle": "Ushbu mahsulot qoralamasi o‘chirilsinmi?",
  "removeDraftDescription": "Ushbu mahsulotning saqlangan ma’lumotlari o‘chiriladi. Buyurtma bosqichi va boshqa mahsulotlar murojaatlari o‘zgarmaydi.",
  "removeReport": "Murojaatni bekor qilish",
  "removeReportTitle": "Ushbu mahsulot bo‘yicha murojaat bekor qilinsinmi?",
  "removeReportDescription": "Ushbu mahsulot bo‘yicha sabab va tuzatishlar qaytarib olinadi. Boshqa mahsulotlar bo‘yicha murojaatlar saqlanadi.",
  "tab": { "parameters": "Parametrlar", "sizes": "O‘lchamlar" },
  "originalValue": "Avval: {{value}}",
  "changed": "O‘zgartirildi",
  "resetComposition": "Komplektatsiya o‘zgarishlarini bekor qilish",
  "resetCompositionTitle": "Komplektatsiya o‘zgarishlari bekor qilinsinmi?",
  "resetCompositionConfirm": "Ha, bekor qilish",
  "keepChanges": "Qoldirish",
  "expandRow": "Ochish",
  "collapseRow": "Yig‘ish",
  "includeRow": "Murojaatga qo‘shish",
  "excludeRow": "O‘zgarishlarni bekor qilish",
  "rowIncluded": "Murojaatda",
  "sizeRows": "Oʻlcham qatorlari: {{count}}",
  "selectedRows": "Tanlangan qatorlar: {{rows}}",
  "rowNote": "Ushbu qatorga izoh",
  "chooseSizes": "Kerakli qatorni oching va tuzatish kiriting.",
  "sizeNumber": "O‘lcham qatori № {{number}}",
  "sharedSelection": "Umumiy komplektatsiyadagi o‘zgarishlar bu o‘lchovning barcha ochiq qatorlariga qo‘llanadi.",
  "sizeLocked": "Bu qator bo‘yicha qaror qabul qilingan yoki u joriy tashrif uchun mavjud emas.",
  "customerAgreement": "Mijoz bilan kelishilgan shartlar / xohishini tekshirish natijasi",
  "confirmAgreement": "Kelishuv va tuzatilgan variantni tasdiqlash",
  "title": "Mahsulotni aniqlashtirish",
  "add": "Sababini ko‘rsatish",
  "editProposal": "Taklifni ko‘rish va aniqlashtirish",
  "attached": "Taklif xabarga biriktirildi",
  "edit": "Tahrirlash",
  "attach": "Taklifni biriktirish",
  "compare": "Parametrlarni solishtirish",
  "before": "Buyurtmada edi",
  "after": "Shunday bo‘lishi kerak",
  "quantity": "Xatoli mahsulotlar soni",
  "of": "jami",
  "comment": "Aynan nima noto‘g‘ri",
  "photo": "Surat",
  "takePhoto": "Suratga olish",
  "choosePhoto": "Galereyadan tanlash",
  "removePhoto": "Suratni aniqlashtirishdan olib tashlash",
  "situation": "Vaziyat",
  "notes": "Boshqaruv tomoni, zanjir va mahsulot izohi",
  "correctSpecification": "To‘g‘ri komplektatsiya",
  "agreement": "Mijoz xohishi o‘zgarishi uchun shartlar va ehtimoliy qo‘shimcha to‘lov alohida kelishiladi.",
  "kind": {
    "SPECIFICATION_ERROR": "Buyurtmada noto‘g‘ri ko‘rsatilgan",
    "ORIGINAL_CORRECT": "Mahsulot buyurtmaga mos emas",
    "REMEASURE": "Qayta o‘lchash kerak",
    "CUSTOMER_REFUSAL": "Mijoz mahsulotdan voz kechdi",
    "CUSTOMER_CHANGE": "Mijoz xohishini o‘zgartirdi"
  },
  "managerTitle": "O‘rnatuvchi taklifi",
  "managerHint": "Izoh va parametrlarni tekshiring. Qarordan oldin tuzatish mumkin; buyurtma summasi qayta hisoblanmaydi.",
  "reviewed": "Taklif ko‘rib chiqildi. Ish qaror tasdiqlangandan keyin boshlanadi.",
  "adopt": "Taklif qilingan variantni ochish",
  "originalReason": "Dastlabki komplektatsiyani saqlash sababi / qayta tekshirish natijasi",
  "keepOriginal": "Ko‘rib chiqildi — dastlabki buyurtmani ishlatish"
};
